import React from 'react';
import { TCollabThread, TiptapCollabProvider } from '@tiptap-pro/provider';

import { Sidebar as SidebarComponent } from 'containers/Tiptap/components/tiptap-templates/Sidebar';
import { SidebarEnum } from 'containers/Tiptap/components/tiptap-templates/types';

interface EditorSidebarProps {
  provider: TiptapCollabProvider;
  threads: TCollabThread[];
  activeSidebar: SidebarEnum | false;
  setActiveSidebar: (sidebar: SidebarEnum | false) => void;
  setSelectedThread: (thread: string | null) => void;
}

export const EditorSidebar: React.FC<EditorSidebarProps> = ({
  provider,
  threads,
  activeSidebar,
  setActiveSidebar,
  setSelectedThread,
}) => (
  <SidebarComponent
    provider={provider}
    threads={threads}
    activeSidebar={activeSidebar}
    setActiveSidebar={setActiveSidebar}
    setSelectedThread={setSelectedThread}
  />
);
